const PREFIX = "User";
export const SET_USER_INFO = `${PREFIX}/SET_USER_INFO`;
export const SET_USER_CONFIG = `${PREFIX}/SET_USER_CONFIG`;
export const SET_USER_QUOTA = `${PREFIX}_SET_USER_QUOTA`;
export const IS_LOADING = `${PREFIX}/IS_LOADING`;
